export default "__VITE_ASSET__XTJp8SQ7__"